import { render, staticRenderFns } from "./SettingProduct.vue?vue&type=template&id=1720be08&"
import script from "./SettingProduct.vue?vue&type=script&lang=js&"
export * from "./SettingProduct.vue?vue&type=script&lang=js&"
import style0 from "./SettingProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports